import React, { useState } from 'react'
import {
  Box,
  SimpleGrid,
  Flex,
  Select,
  Button,
  useDisclosure,
} from '@chakra-ui/react'
import VideoDashboard from './components/videoDashboard'
import { CreateVideoModal } from './components/CreateVideoModal'

export default function Videos() {
  const [filterType, setFilterType] = useState('all')
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Flex justifyContent="space-between" alignItems="center" mb={4} flexWrap="wrap" gap={4}>
        <Select
          width={{ base: '100%', md: '300px' }}
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          bg="white"
          _dark={{ bg: 'navy.800' }}
        >
          <option value="all">All Videos</option>
          <option value="youtube">YouTube Highlights</option>
          <option value="promo">Promo Videos</option>
        </Select>

        <Button
          colorScheme="brand"
          onClick={onOpen}
        >
          Add Video
        </Button>
      </Flex>

      <SimpleGrid columns={{ base: 1 }} gap='20px'>
        <VideoDashboard filterType={filterType} />
      </SimpleGrid>

      <CreateVideoModal isOpen={isOpen} onClose={onClose} />
    </Box>
  )
}
